import { anodum } from '@yola/ws-sdk';
import getElementAttributes from './get-element-attributes';
import applyAttributesToElement from './apply-attributes-to-element';

function getIframeOuterHtml(element) {
  if (anodum.isTag(element, 'ws-iframe')) {
    const iframe = document.createElement('iframe');
    const attributes = getElementAttributes(element);

    applyAttributesToElement(iframe, attributes);

    return iframe.outerHTML;
  }

  return element.outerHTML;
}

export default getIframeOuterHtml;
